
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  setProductAccount,
  walletDetails,
  aloneSetConfig,
  getServerSidePlugin
} from '@/api/product/productAccount'
import { clipboardSuccess } from '@/utils/clipboard'
import changeTime from './changeTime.vue'
import addPayMoney from './addPayMoney.vue'
import { addressRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
// import editWallet from './editWallet.vue'
import { getBnakList } from '@/api/universal'
import { getAllGcash } from '@/api/gcash/groups'
import baseUploader from '@/components/BaseFile/index.vue'
import axios from 'axios'
import { queryAddressInfo, setApplysig } from '@/api/product/product'

@Component({
  name: 'editAccountConfig',
  components: {
    changeTime,
    addPayMoney,
    baseUploader
    // editWallet,
  }
})
export default class extends Vue {
  @Prop() account!: any
  @Prop({ default: true }) isEdit!: boolean
  @Prop({ required: false }) addPay!: any
  @Prop({ required: true }) params!: any
  @Prop({ required: true }) accountType!: any
  @Prop({ required: false }) productId!: any

  private clipboardSuccess = clipboardSuccess
  private product = this.accountType
  private centerDialogVisible: boolean = false
  private dialogVisible: boolean = false
  private dialogVisible1: boolean = false
  private collectWallet: any = ''
  private feeWallet: any = ''
  private walletInfo: any = {}
  private formType: boolean = false
  @Watch('account.account_type', { immediate: true })
  private onAccountChange() {
    if (this.account.account_type) {
      this.$nextTick(() => {
        this.init()
      })
    }
  }
  private config: any[] = []
  private form: any = {}
  private formInfo = this.form
  private field: any = ''

  private condition = ['.jpg', '.png', '.jpeg', '.gif', '.ico']
  private fileNmae = ['.txt']

  private clickFile(item: any) {
    window.open(item)
  }

  private getLogo(logo: any) {
    this.form['photo_target_base64'] = logo
  }

  private loading: boolean = false
  private bankList: any[] = []
  // private rules = accountConfigRules
  private addressRules = addressRules

  // -------- api key添加操作 ----------
  private apiKeyDialog: boolean = false
  private apiKey: any = []
  private openApiKey() {
    if (!this.account.extra_param) {
      this.apiKey = []
    } else if (this.account.extra_param.api_key) {
      this.apiKey = this.account.extra_param.api_key
    }
    this.apiKeyDialog = true
  }
  private closeApiKey() {
    if (this.apiKey.length > 0) {
      this.apiKey = this.apiKey.filter(item => item !== '')
    } else {
      this.apiKey = []
    }
    this.apiKeyDialog = false
  }
  private saveApiKey() {
    this.apiKey = this.apiKey.filter(item => item !== '')
    this.apiKeyDialog = false
  }
  private addCm() {
    this.apiKey.push('')
  }
  private removeCm(index: number) {
    this.apiKey.splice(index, 1)
  }

  private addApiKey() {}

  // -------api key添加操作 End---------------

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 子组件给父组件传值
  private getTableValue(value, field) {
    this.form[field] = value
  }

  // 打开创建组件
  private openDialogVisible(field) {
    this.field = field
    this.dialogVisible = true
  }
  // 打开编辑组件
  private async openDialogVisible1(address) {
    await this.walletDetails(address)
    this.dialogVisible1 = true
  }
  private closeDialogVisible(address) {
    if (address !== undefined) {
      this.form[this.field] = address
    }
    this.dialogVisible = false
  }
  private closeDialogVisible1(address) {
    if (address !== undefined) {
      this.form[this.field] = address
    }
    this.dialogVisible1 = false
  }

  private clear(address) {
    this.form[address] = ''
  }
  /** 判断当前钱包是否存在值*/
  private isWallet: boolean = false

  private init() {
    this.config = this.params[this.account.account_type]
    if (this.config === undefined) return false
    let showKey: any = []
    this.config.forEach(c => {
      if (c.type === 'hr' || (c.type === 'array' && c.array)) {
        this.formType = true
      }
      const extra_param = this.account.extra_param
      let value: any = null
      if (c.value) {
        value = c.value
      } else {
        value = extra_param && extra_param[c.field] ? extra_param[c.field] : ''
      }
      if (c.type === 'show' || c.type === 'hidden' || c.type === 'hr') {
        showKey.push(c.field)
      }
      if (c.type === 'gcash_group') {
        this.onloadGroupList()
      }
      this.$set(this.form, c.field, value)
    })
    // 判断是否处于编辑状态
    if (this.isEdit) {
      // type为show的类型为空
      if (showKey.length === 0) {
        for (var key in this.form) {
          // 判断编辑接口的值是否为空
          if (this.addPay[key] !== undefined) {
            this.form[key] = this.addPay[key]
          }
        }
      } else {
        // 先循环赋值给编辑接口获取的值
        showKey.forEach(element => {
          this.addPay[element] = this.form[element]
        })
        for (var key in this.form) {
          if (this.addPay[key] !== undefined) {
            // 当编辑接口的值不为空，就从编辑处拿
            this.form[key] = this.addPay[key]
          }
        }
      }
    }
    console.log(this.config, this.form, 'ooooo')

    if (this.form.pay_wallet || this.form.fee_wallet) {
      let address = this.form.pay_wallet
        ? this.form.pay_wallet
        : this.form.fee_wallet
      this.queryWallet(address)
    }
  }

  /** 查询pay_wallet和*fee_wallet*/
  private walletAddress: any = ''
  private async queryWallet(wallet: string) {
    this.walletAddress = wallet
    let data: any = {
      address: wallet
    }
    await queryAddressInfo(data).then((res: any) => {
      if (
        res.has_multi_sig === false &&
        (this.accountType.code === 'USDT-TRC20Payout' ||
          this.accountType.code === 'USDT-ERC20Payout')
      ) {
        this.isWallet = true
      } else {
        this.isWallet = false
      }
    })
  }

  private sigLoading: boolean = false
  private async applySig() {
    this.sigLoading = true
    let data: any = {
      wallet_address: this.walletAddress
    }
    await setApplysig(data)
      .then(() => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.isWallet = false
        this.sigLoading = false
      })
      .catch(() => {
        this.isWallet = true
        this.sigLoading = false
      })
  }

  private groupList: any = []
  // gcash分组列表
  private async onloadGroupList() {
    try {
      let params: any = {
        page_size: 100,
        page: 1
      }
      await getAllGcash(params).then((res: any) => {
        this.groupList = res.results
      })
    } catch (e) {
      console.log()
    }
  }

  // 钱包详情
  private async walletDetails(address) {
    try {
      await walletDetails(address).then((res: any) => {
        this.walletInfo = res
      })
    } catch (e) {
      this.$message({
        message: 'Wrong Wallet Address. Please try again!',
        type: 'error',
        customClass: 'zZindex'
      })
    }
  }

  private back() {
    this.$emit('close', false)
  }

  private async update() {
    try {
      this.loading = true
      this.flag = true
      const data = {
        extra_param: {
          ...this.form,
          api_key: this.apiKey
        },
        id: this.account.id
      }
      await setProductAccount(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.loading = false
        this.flagStr()
        this.$emit('next')
      })
    } catch (e) {
      this.loading = false
      this.flagStr()
    }
  }

  // Fund Collection Wallet 单独设置弹窗
  private dialogEditCollectWallet: boolean = false
  private openEditCollectWallet() {
    this.dialogEditCollectWallet = true
  }

  private closeEditCollectWallet() {
    this.form.collect_wallet = ''
    this.form.google_code = ''
    this.dialogEditCollectWallet = false
  }

  private upConfig() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data: any = {
            product_account_id: this.account.id,
            field: 'collect_wallet',
            value: this.form.collect_wallet,
            google_code: this.form.google_code
          }
          await aloneSetConfig(data).then(() => {
            this.$message({
              message: 'Save successful!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.dialogEditCollectWallet = false
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  // 获取产品银行列表
  private async getBankList() {
    const data: any = {
      id: this.productId.id
    }
    await getBnakList(data).then((res: any) => {
      this.bankList = res
    })
  }

  private getBase64(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader()
      let fileResult: any = ''
      reader.readAsDataURL(file)
      // 开始转
      reader.onload = function () {
        fileResult = reader.result
      }
      // 转 失败
      reader.onerror = function (error) {
        reject(error)
      }
      // 转 结束  咱就 resolve 出去
      reader.onloadend = function () {
        resolve(fileResult)
      }
    })
  }

  private httpRequest(data) {
    // this.imageUrl = URL.createObjectURL(data.file)
    // 这是限制上传文件类型
    const isPFX =
      data.file.type === 'image/jpeg' ||
      data.file.type === 'image/jpg' ||
      data.file.type === 'image/png'
    const isLt2M = data.file.size / 1024 / 1024 < 2
    if (!isPFX) {
      this.$message.error('The image format can only be jpeg/png/jpg!')
    } else if (!isLt2M) {
      this.$message.error('File size should not exceed 5MB!')
    } else {
      this.getBase64(data.file).then((resBase64: any) => {
        this.form['photo_target_base64'] = resBase64.split(',')[1] // 直接拿到base64信息
      })
    }
  }

  private delImg(item: any) {
    this.form['photo_target_base64'] = ''
  }
  private dialogVisibleImg: boolean = false
  private previewImg() {
    this.dialogVisibleImg = true
  }
  public imgName: any = ''
  public nowFile: any = ''
  private beforeAvatarUpload(file) {
    this.imgName = file.name
    this.nowFile = file
    // const fileName = file.name
    // const fileType = fileName.substring(fileName.lastIndexOf('.'))
    // const isLt5M = file.size / 1024 / 1024 < 5
    // const isOKType = fileType === '.jpg' || fileType === '.png' || fileType === '.jpeg' || fileType === '.bmp' || fileType === '.gif'
    // if (!isOKType) return this.$message.error('The image format can only be jpeg/png/jpg/bmp/gif!')
    // if (!isLt5M) return this.$message.error('File size should not exceed 5MB!')
    // return isOKType && isLt5M
  }

  // 上传图片
  private async upImg() {
    const data: any = {
      action: 'upload_face',
      product_account: this.account.id,
      data: {
        photo_target_base64: this.form['photo_target_base64']
      }
    }
    await getServerSidePlugin(data).then(() => {
      this.$message({
        message: 'Upload successful',
        type: 'success'
      })
    })
  }

  // 打开图片
  private imgDialog: boolean = false
  private imgArr: any = []
  private showImg(val) {
    this.imgArr = val.help
    this.imgDialog = true
  }
  private closeImg() {
    this.imgDialog = false
  }

  private showViewer: boolean = false
  private carouselClick(event) {
    this.showViewer = true
  }
  private closeViewer() {
    this.showViewer = false
  }

  // 编辑有效时间
  private timeVisible: boolean = false
  private timeData: any = []
  private timeStr: any = ''
  private editGroup(val: any, str: string) {
    this.timeData = val
    this.timeStr = str
    this.timeVisible = true
  }
  private closeTimeVisible() {
    this.timeVisible = false
  }
  private changeTimeData(val) {
    this.timeData = val
    this.timeVisible = false
    this.$set(this.form, this.timeStr, this.timeData)
  }

  mounted() {
    if (this.productId) {
      this.getBankList()
    }
  }
}
